import { useEffect, useState } from "react";
import api, { fmtDate, fmtNZD } from "@/lib/api";

export default function CompleteJobDialog({ project, onClose, onDone }) {
  const [chk, setChk] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/projects/${project.id}/close-check`).then(r => setChk(r.data)).catch(() => setChk({ bills: [], timesheets: [] }));
  }, [project.id]);

  async function close() {
    setBusy(true); setErr("");
    try { await api.post(`/projects/${project.id}/complete`); onDone(); }
    catch (e) { setErr(e?.response?.data?.detail || "Couldn't complete"); setBusy(false); }
  }

  const warn = chk && (chk.bills.length > 0 || chk.timesheets.length > 0);
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" data-testid="complete-job-dialog">
      <div className="card w-full max-w-md space-y-3">
        <h2 className="text-silver text-lg">Complete project</h2>
        <p className="text-sm opacity-80">Workers won't see <b>{project.name}</b> or be able to log hours to it. Nothing is deleted, and you can reopen it at any time.</p>
        {!chk ? <div className="text-sm opacity-60">Checking…</div> : warn ? (
          <div className="border border-amber-500/50 bg-amber-500/10 rounded p-2 text-sm text-amber-200 space-y-1" data-testid="complete-job-warning">
            <div className="font-medium">Still outstanding on this project:</div>
            {chk.bills.map(b => <div key={b.id}>• Bill {b.supplier || "—"} {b.number || ""} · {fmtNZD(b.total)} · {b.status}</div>)}
            {chk.timesheets.map(t => <div key={t.id}>• Timesheet {t.worker_name || "—"} · {fmtDate(t.work_date)} · {t.total_hours} h · {t.status}</div>)}
          </div>
        ) : <div className="text-sm text-green-400" data-testid="complete-job-clear">No bills awaiting review or unapproved timesheets.</div>}
        {err && <div className="text-red-400 text-sm" data-testid="complete-job-error">{err}</div>}
        <div className="flex gap-2 justify-end">
          <button className="btn-ghost" onClick={onClose} data-testid="complete-job-cancel">Cancel</button>
          <button className="btn-silver" disabled={!chk || busy} onClick={close} data-testid="complete-job-confirm">{warn ? "Close anyway" : "Complete project"}</button>
        </div>
      </div>
    </div>
  );
}
